


import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const resetExecutionData = async (teststepid) => {
  const userDetail = localStorage.getItem("userDetail");
  if (!userDetail) throw new Error("No user details found in localStorage");
  
  
  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=reset&teststepid=${teststepid}`,
  );
  
  return response.data;
};

const useResetExecutionData = (teststepid, options = {}) => {
  return useMutation({
    mutationFn: () => resetExecutionData(teststepid),
    ...options,
  });
};

export default useResetExecutionData;